// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1155537f","453":"fadc3cd2","553":"ba4e4485"}[chunkId] + ".chunk.js";
};